import React, { useEffect } from 'react';

function PaymentSuccessModal({ result, onClose }) {
  useEffect(() => {
    // Auto-close after 5 seconds for success
    if (result.status === 'success') {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [result.status, onClose]);

  const getModalContent = () => {
    switch (result.status) {
      case 'success':
        return {
          title: '🎉 Booking Confirmed!',
          message: `Your booking has been successfully confirmed.`,
          details: result.bookingReference 
            ? `Booking Reference: ${result.bookingReference}`
            : 'Confirmation email has been sent.',
          bgColor: 'bg-green-50',
          borderColor: 'border-green-200',
          textColor: 'text-green-800'
        };
      case 'cancelled':
        return {
          title: 'Payment Cancelled',
          message: 'Your payment was cancelled.',
          bgColor: 'bg-yellow-50',
          borderColor: 'border-yellow-200',
          textColor: 'text-yellow-800'
        };
      case 'failed':
        return {
          title: 'Payment Failed',
          message: 'Payment processing failed. Please try again.',
          bgColor: 'bg-red-50',
          borderColor: 'border-red-200',
          textColor: 'text-red-800'
        };
      case 'error':
      case 'exception':
        return {
          title: 'Payment Error',
          message: 'An error occurred during payment processing.',
          bgColor: 'bg-red-50',
          borderColor: 'border-red-200',
          textColor: 'text-red-800'
        };
      default:
        return {
          title: 'Payment Status',
          message: 'Payment processing completed.',
          bgColor: 'bg-gray-50',
          borderColor: 'border-gray-200',
          textColor: 'text-gray-800'
        };
    }
  };

  const content = getModalContent();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className={`${content.bgColor} ${content.borderColor} ${content.textColor} rounded-xl shadow-2xl max-w-md w-full border`}>
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h3 className="text-xl font-bold">{content.title}</h3>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-xl"
            >
              ✕
            </button>
          </div>
          
          <p className="mb-3">{content.message}</p>
          
          {content.details && (
            <div className="mb-4 p-3 bg-white rounded-lg border">
              <p className="font-semibold">{content.details}</p>
              {result.bookingReference && (
                <p className="text-sm mt-1 text-gray-600">
                  Confirmation email has been sent to your registered email address.
                </p>
              )}
            </div>
          )}
          
          <div className="flex justify-end space-x-3 mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Close
            </button>
          </div>
          
          {result.status === 'success' && (
            <p className="text-xs text-gray-500 mt-4 text-center">
              This message will auto-close in 5 seconds
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccessModal;